export default class Helper {
  static elementWidth (elem) {
    return elem.offsetWidth
  }

  static elementMedium (elem) {
    return (this.elementWidth(elem) / 2)
  }

  static widthUnder600 () {
    return (this.elementWidth(document.body) < 600)
  }

  static circleTopPosition () {
    if (this.widthUnder600 === true) {
      return 783
    } else {
      return 722
    }
  }
}
